import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-completar-cadastro',
  templateUrl: './completar-cadastro.component.html',
  styleUrls: ['./completar-cadastro.component.scss']
})
export class CompletarCadastroComponent implements OnInit {
  clienteForm: FormGroup;
  isEditing: boolean = true;
  empresaIdEncrypted: string;
  
  // Properties for the table
  dtOptions: DataTables.Settings = {};
  clientes: any[] = [];
  cidades: any[] = [];
  
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private ajax: AjaxService,
    public util: UtilService
  ) {
    this.clienteForm = this.fb.group({
      // Basic company information
      nomeFantasia: ['', Validators.required],
      razaoSocial: ['', Validators.required],
      cnpj: ['', Validators.required],
      dataFundacao: [''],
      cnes: [''],
      isEmpresaGestora: [false],
      
      // Professional identification
      pessoaNome: [''],
      pessoaCpf: [''],
      pessoaEmail: ['', Validators.email],
      pessoaDataNascimento: [''],
      pessoaTelefone: [''],
      
      // Location
      endereco: [''],
      numero: [''],
      bairro: [''],
      idCidade: [''],
      
      // Contact information
      telefonePrincipal: [''],
      telefoneAuxiliar: [''],
      telefoneWhatsapp: [''],
      site: [''],
      email: ['', Validators.email],
      funcionamento: [''],
      secretariaAtendente: [''],
      
      // Technical responsible
      responsavelNome: [''],
      responsavelConselho: [''],
      responsavelRegistro: [''],
      
      // Administrator
      admNome: [''],
      admFuncao: [''],
      admCelular: [''],
      admEmail: ['', Validators.email],
      
      // Additional information
      servicosOfertados: [''],
      observacao: ['']
    });
  }

  ngOnInit(): void {
    this.empresaIdEncrypted = this.route.snapshot.paramMap.get('idEncrypted');
    this.carregarDadosEmpresa();
    this.carregarCidades();
    this.configurarDataTable();
  }

  configurarDataTable(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.24/i18n/Portuguese-Brasil.json'
      },
      responsive: true,
      order: [[0, 'desc']]
    };
  }

  carregarCidades(): void {
    this.util.showLoading();
    this.ajax.get(`${API}Cidade/GetAll`)
      .subscribe({
        next: (response: any) => {
          this.cidades = response.data;
          this.util.closeLoading();
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError('Erro', 'Erro ao carregar cidades');
          console.error('Erro ao carregar cidades:', error);
        }
      });
  }

  carregarDadosEmpresa(): void {
    this.util.showLoading();
    this.ajax.get(`${API}Empresa/EmpresaExterna/${this.empresaIdEncrypted}`)
      .subscribe({
        next: (response: any) => {
          const empresa = response.data;
          this.clienteForm.patchValue({
            nomeFantasia: empresa.nomeFantasia || '',
            razaoSocial: empresa.razaoSocial || '',
            cnpj: empresa.cnpj || '',
            dataFundacao: empresa.dataFundacao || '',
            cnes: empresa.cnes || '',
            isEmpresaGestora: empresa.isEmpresaGestora || false,
            pessoaNome: empresa.pessoaNome || '',
            pessoaCpf: empresa.pessoaCpf || '',
            pessoaEmail: empresa.pessoaEmail || '',
            pessoaDataNascimento: empresa.pessoaDataNascimento || '',
            pessoaTelefone: empresa.pessoaTelefone || '',
            endereco: empresa.endereco || '',
            numero: empresa.numero || '',
            bairro: empresa.bairro || '',
            idCidade: empresa.idCidade || '',
            telefonePrincipal: empresa.telefonePrincipal || '',
            telefoneAuxiliar: empresa.telefoneAuxiliar || '',
            telefoneWhatsapp: empresa.telefoneWhatsapp || '',
            site: empresa.site || '',
            email: empresa.email || '',
            funcionamento: empresa.funcionamento || '',
            secretariaAtendente: empresa.secretariaAtendente || '',
            responsavelNome: empresa.responsavelNome || '',
            responsavelConselho: empresa.responsavelConselho || '',
            responsavelRegistro: empresa.responsavelRegistro || '',
            admNome: empresa.admNome || '',
            admFuncao: empresa.admFuncao || '',
            admCelular: empresa.admCelular || '',
            admEmail: empresa.admEmail || '',
            servicosOfertados: empresa.servicosOfertados || '',
            observacao: empresa.observacao || ''
          });
          this.util.closeLoading();
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError('Erro', 'Erro ao carregar dados da empresa');
          console.error('Erro ao carregar dados da empresa:', error);
          this.router.navigate(['/pre-cadastro-cliente']);
        }
      });
  }

  onSubmit(): void {
    if (this.clienteForm.valid) {
      this.util.showLoading();
      this.ajax.put(`${API}Empresa/Empresa/UpdateByIdEncrypted/${this.empresaIdEncrypted}`, this.clienteForm.value)
        .subscribe({
          next: () => {
            this.util.closeLoading();
            this.util.toasterShowSuccess('Sucesso', 'Cadastro completado com sucesso!');
            this.router.navigate(['/pre-cadastro-cliente']);
          },
          error: (error) => {
            this.util.closeLoading();
            this.util.toasterShowError('Erro', 'Erro ao completar cadastro');
            console.error('Erro ao completar cadastro:', error);
          }
        });
    }
  }

  toggleEdit(): void {
    this.isEditing = !this.isEditing;
  }

  // Methods for the table
  editarCliente(cliente: any): void {
    // Implementation for editing a client
    console.log('Editar cliente:', cliente);
  }

  alterarStatus(cliente: any): void {
    // Implementation for changing client status
    console.log('Alterar status do cliente:', cliente);
  }
} 